import LoadingGif from '~/images/icons/loading.gif';
import MapViewButtons from '~/javascripts/components/User/ProfileMap/MapViewButtons';
import mapboxgl from 'mapbox-gl';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { pauseForSpecs } from '~/javascripts/utils/testing';
import { pulsingDot } from '~/javascripts/utils/mapbox';
import { useLayoutEffect, useRef } from 'react';

const Map = observer((props) => {
  const mapEl = useRef(null);

  useLayoutEffect(() => {
    initializeMap();

    store.projectDetailsMap.map.on('style.load', () => {
      store.projectDetailsMap.map.addImage('pulsing-dot', pulsingDot(80), {
        pixelRatio: 2,
      });

      store.projectDetailsMap.addProjectsToMap();

      panToProject();
    });

    pauseForSpecs(() => {
      store.projectDetailsMap.map.on('idle', () => {
        store.projectDetailsMap.loading = false;
      });
    });
  }, []);

  const initializeMap = () => {
    mapboxgl.accessToken = props.accessToken;
    store.projectDetailsMap.map = new mapboxgl.Map({
      container: mapEl.current,
      center: [0, 0],
      zoom: 3.75,
      maxZoom: props.mapDefaultZoomLevel,
    });
    store.projectDetailsMap.activeMapView = 'terrain';
    store.projectDetailsMap.setMapStyle();

    window.map = store.projectDetailsMap.map;
    window.mapboxgl = mapboxgl;

    store.projectDetailsMap.map.scrollZoom.disable();
    const navigation = new mapboxgl.NavigationControl({ showCompass: false });
    store.projectDetailsMap.map.addControl(navigation);
    map.on('resize', () => setMapPadding());

    map.on('load', () => {
      setMapPadding();
    });
    // Create a popup, but don't add it to the map yet.
    // To be used when auto-panning after project card select
    store.projectDetailsMap.tooltipPopup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });
    store.projectDetailsMap.fitAndZoomMap();
  };

  const offsetBp = window.matchMedia('(min-width: 600px)');

  const setMapPadding = () => {
    if (offsetBp.matches) {
      map.setPadding({ left: 400, bottom: 0 });
      return;
    }
    map.setPadding({ left: 0, bottom: 520 });
  };

  const panToProject = () => {
    console.log('in panToProject');
    const panTo = document.querySelector(
      '.outer-slider .swiper-slide-active .inner-slider .swiper-slide-active'
    );
    if (panTo) {
      store.projectDetailsMap.removeExistingTooltip();
      const panToLat = panTo.getAttribute('data-lat');
      const panToLon = panTo.getAttribute('data-lon');
      const panToZ = panTo.getAttribute('data-zoom');
      const panToName = panTo.getAttribute('data-name');
      map.jumpTo({
        center: [panToLon, panToLat],
      });

      map.easeTo({
        zoom: panToZ,
        speed: 0.2,
        curve: 1,
        duration: 1500,
      });

      // Open the popup of the marker panned to.
      store.projectDetailsMap.tooltipPopup
        .setLngLat([panToLon, panToLat])
        .setHTML(panToName)
        .addTo(map);
    }
  };

  return (
    <div className='map relative'>
      {store.projectDetailsMap.loading && (
        <div className='map-loading'>
          <img src={LoadingGif} />
        </div>
      )}
      <div ref={mapEl} />
      <MapViewButtons />
    </div>
  );
});

export default Map;
